<script>
import ModalHistoryComponent from '../../features/modals/ModalHistoryComponent'

export default {
    name:'ModalHistoryView',
    extends: ModalHistoryComponent
}
</script>
<template>
  <el-dialog
    v-model="conf.isVisible"
    :title="conf.title"
    class="discount-modal-history"
    width="85%"
    append-to-body
    :before-close="onAccept"
    :close-on-click-modal="false"
  >
    <el-form
      ref="formData"
      v-loading="conf.isLoading"
      :model="formData"
      :rules="rules"
      status-icon
      :label-position="'top'"
    >
      <el-row :gutter="20">
        <fieldset>
          <legend>FILTROS DE BUSQUEDA</legend>
          <el-col
            :xs="24"
            :sm="12"
            :md="12"
            :lg="9"
            :xl="7"
          >
            <el-form-item>
              <el-select
                v-model="formData.discount"
                size="small"
                filterable
                remote
                reserve-keyword
                clearable
                placeholder="Cupon de descuento"
                :remote-method="onSearchDiscounts"
                value-key="id"
                @change="onAllFilterChange(formData.discount, 'DiscountId')"
              >
                <el-option
                  v-for="item in discounts"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col
            :xs="24"
            :sm="12"
            :md="12"
            :lg="9"
            :xl="7"
          >
            <el-form-item>
              <el-date-picker
                v-model="formData.rangeDate"
                :disabled="!formData.discount"
                size="small"
                type="daterange"
                range-separator="-"
                start-placeholder="F. Inicio"
                end-placeholder="F. Fin"
                value-format="YYYY-MM-DD"
                format="DD MMM YYYY"
                @change="onRangeDate(formData.rangeDate, 'StartDate', 'EndDate')"
              />
            </el-form-item>
          </el-col>
        </fieldset>
      </el-row>
      <el-row
        :gutter="20"
        style="margin-top: -20px"
      >
        <fieldset>
          <legend>LISTA DE RESULTADOS</legend>
          <el-table
            v-loading="isItemLoading"
            :data="collectionHistory"
            empty-text="No se encontraron resultados."
            element-loading-spinner="el-icon-loading"
            :element-loading-text="itemLoadingMessage"
            height="500px"
          >
            <el-table-column
              label=""
              width="70"
            >
              <template #default="scope">
                <div>
                  <el-avatar :src="mapProfileImage(scope.row.userProfile)" />
                </div>
              </template>
            </el-table-column>
            <el-table-column
              label="NOMBRE"
              min-width="350"
            >
              <template #default="scope">
                <div>
                  <el-tag
                    type="info"
                    effect="plain"
                  >
                    {{ scope.row.userProfile.firstName }} {{ scope.row.userProfile.lastName }}
                  </el-tag>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              label="CORREO"
              min-width="350"
            >
              <template #default="scope">
                <div>
                  <el-tag
                    type="info"
                    effect="plain"
                  >
                    {{ scope.row.userProfile.email }}
                  </el-tag>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              label="CARRERAS"
              min-width="100"
              align="center"
            >
              <template #default="scope">
                <el-popover
                  v-if="sizeCareers(scope.row.careers)"
                  placement="bottom"
                  width="300"
                  height="50"
                  trigger="click"
                >
                  <el-table :data="scope.row.careers">
                    <el-table-column
                      min-width="350"
                      property="name"
                      label="Carreras"
                    />
                  </el-table>
                  <template #reference>
                    <el-button
                      type="primary"
                      size="small"
                      align="center"
                      class="btn-primary"
                    >
                      Ver
                    </el-button>
                  </template>
                </el-popover>
              </template>
            </el-table-column>
            <el-table-column
              label="ACTIVO"
              min-width="120"
              align="center"
            >
              <template #default="scope">
                <el-switch
                  v-model="scope.row.userProfile.status"
                  disabled
                  active-color="#13ce66"
                  active-text="SI"
                  inactive-text="NO"
                  size="small"
                  :inactive-value="1"
                  :active-value="2"
                />
              </template>
            </el-table-column>
          </el-table>
        </fieldset>
      </el-row>
    </el-form>
    <template #footer>
      <span class="dialog-footer">
        <el-button
          size="small"
          class="btn-cancel"
          @click="onAccept"
        >Aceptar</el-button>
      </span>
    </template>
  </el-dialog>
</template>